import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { transcriptToolCallSpacing } from "./transcriptSpacing.js";

export interface TranscriptContainerProps {
  /** Transcript messages, call markers, and any events between them. */
  children: ReactNode;
}

export const TranscriptContainer: FC<TranscriptContainerProps> = (props) => {
  return (
    <div
      className={twMerge(
        "flex flex-col text-sm [&>*+*]:mt-2",
        transcriptToolCallSpacing,
      )}
    >
      {props.children}
    </div>
  );
};
